/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CustomerView',["$log","$filter","$dialog","$timeout","Customer","CustomerData","CustomerSrv","ReadOnlyBookingView","Format","DayData","SaleData","GiftItemData",
        "GiftItemView","CureItemView","CureItemData","BookingData","HumanResourceData","LoyaltyCardItemData","OptInOutData","OptInOutView","PhoneFormat",
        "CustomerPostData","CustomerPostView","IOSDevice","SaleStatus", "Images",
        function ($log,$filter,$dialog,$timeout,Customer,CustomerData,CustomerSrv,ReadOnlyBookingView,Format,DayData,SaleData,GiftItemData,
                  GiftItemView,CureItemView,CureItemData,BookingData,HumanResourceData,LoyaltyCardItemData,OptInOutData,OptInOutView,PhoneFormat,
                  CustomerPostData,CustomerPostView,IOSDevice,SaleStatus, Images) {
            //"Manessiez Beatrice"
            var CustomerView = function (customer, cIndex, domainView) {
                this.cIndex = cIndex;
                this.domainView = domainView;
                this.lastName = null;
                this.firstName = null;
                this.gender = null;
                this.label = null;
                this.customerLabelSearch = null;
                this.labelLowerCase = null;
                this.phone = null;
                this.landline = null;
                this.email = null;
                this.login = null;
                this.comment = null;
                this.isVerified = false;
                this.password = null;
                this.passwordAgain = null;
                this.currentPassword = null;
                this.address1 = null;
                this.address2 = null;
                this.city = null;
                this.postCode = null;
                this.origin = null;
                this.online = 'A';//A:active /B : blocked / P : only payment allowed
                this.isBirthDate = false;
                this.birthDate = null;
                this.birthDateString = null;
                this.pastBookingsView = null; //SimpleBookingView
                this.futureBookingsView = null;//SimpleBookingView
                this.historyBookingsView = [];
                this.historySoldSalesView = [];
                this.globalHistoryView = [];
                this.techNoteHistory = [];
                this.historySoldPrice = 0;
                this.historyRealPaidPrice = 0;
                this.historyCaPrice = 0;
                this.nbNotCameBookings = 0;
                this.nbCameBookings = 0;
                this.nbSoldSales = 0;
                this.nbWaitingSales = 0;
                this.nbEstimationSales = 0;
                this.nbUnpaidSales = 0;
                this.nbAdvanceSales = 0;
                this.lastVisitDate = null;
                this.cureItemsUsedView = [];
                this.cureItemsNotUsedView = [];
                this.nbCureItemUsed = 0;
                this.nbCureItemNotUsed = 0;
                this.giftItemsUsedView = [];
                this.giftItemsNotUsedView = [];
                this.giftItemsCanceledView = [];
                this.loyaltyCardItemsUsedView = [];
                this.loyaltyCardItemsNotUsedView = [];
                this.nbGiftItemsUsed = 0;
                this.nbGiftItemsNotUsed = 0;
                this.nbLoyaltyCardItemNotUsed = 0;
                this.nbLoyaltyCardItemUsed = 0;
                this.nbTechNotes = 0;
                this.customerInterNationalMobileNumber = null;
                this.customerNationalMobileNumber = null;
                this.customerInterNationalLandlineNumber = null;
                this.customerNationalLandlineNumber = null;
                this.hasWebPwd = false;
                this.hasMobileApp = false;
                this.optInOutView = new OptInOutView(null, null);
                this.isCGVAccepted = null;
                this.phoneDisplay = '';
                this.idReserveWithGoogle = null;
                this.isHistoryInit = false;
                this.loadDataFromWithoutInitHistory(customer);
                this.bookingStatusImage = Images.saleStatus;
            };
            CustomerView.prototype.getModel = function () {
                if (this.cIndex != -1)
                    return CustomerData.getByIndex(this.cIndex);
                return null;
            };

            //Dupplicate method with customer model to avoid nullPointer on customer creation
            CustomerView.prototype.loadCustomerLabelSearch = function (customer) {
                if(customer.customerLabelSearch) {
                    this.customerLabelSearch = customer.customerLabelSearch;
                } else {
                    this.customerLabelSearch = customer.lastName + " " + customer.firstName + " | ";
                    if (customer.phone) {
                        let phone = customer.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
                        this.customerLabelSearch += phone;
                    } else if (customer.landline) {
                        this.customerLabelSearch += PhoneFormat.formatNumberWithoutCountry(customer.landline);
                    }
                }
            };

            //Dupplicate method with customer model to avoid nullPointer on customer creation
            CustomerView.prototype.createInterNationalAndNationalPhoneFormat = function(customer){
                if(customer) {
                    this.customerNationalMobileNumber = customer.customerNationalMobileNumber;
                    this.customerInterNationalMobileNumber = customer.customerInterNationalMobileNumber;
                    this.customerInterNationalLandlineNumber = customer.customerInterNationalLandlineNumber;
                    this.customerNationalLandlineNumber = customer.customerNationalLandlineNumber;
                } else {
                    this.customerNationalMobileNumber = PhoneFormat.returnNationalFormat(this.phone).replace(/\s/g, '');
                    this.customerInterNationalMobileNumber = PhoneFormat.returnInternationalFormat(this.phone).replace(/\s/g, '');
                    this.customerInterNationalLandlineNumber = PhoneFormat.returnInternationalFormat(this.landline).replace(/\s/g, '');
                    this.customerNationalLandlineNumber = PhoneFormat.returnNationalFormat(this.landline).replace(/\s/g, '')
                }
            };

            CustomerView.prototype.loadDataFrom = function (customer) {
                if (customer !== undefined && customer) {
                    this.loadDataFromWithoutInitHistory(customer);
                    this.initCustomerHistoryDatas(customer);
                }
            };

            CustomerView.prototype.initCustomerHistoryDatas = function (customer) {
                if (customer !== undefined && customer) {
                    this.initHistoryView();
                    this.initGiftItemsView();
                    this.optInOutView = new OptInOutView(customer.optInOut, OptInOutData.getIndexOf(customer.optInOut));
                    this.optInOutView.customerId = customer.id;
                }
            };

            CustomerView.prototype.loadDataFromWithoutInitHistory = function (customer) {
                if (customer !== undefined && customer) {
                    this.lastName = customer.lastName;
                    this.firstName = customer.firstName;

                    if (customer.phone)
                        this.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
                    this.createInterNationalAndNationalPhoneFormat(customer);
                    this.loadCustomerLabelSearch(customer);

                    this.label = customer.lastName + " " + customer.firstName;
                    if (this.label)
                        this.labelLowerCase = this.label.toLowerCase();
                    this.phone = customer.phone;
                    this.landline = customer.landline;
                    this.customerPhone = customer.phone;
                    if (customer.email)
                        this.email = customer.email.toLowerCase();
                    this.comment = customer.comment;
                    this.gender = customer.gender;
                    this.isVerified = customer.isVerified;
                    this.address1 = customer.address1;
                    this.address2 = customer.address2;
                    this.city = customer.city;
                    this.postCode = customer.postCode;
                    this.origin = customer.origin;
                    if (customer.online)
                        this.online = customer.online;
                    this.isBirthDate = customer.isBirthDate;
                    this.birthDate = customer.birthDate;
                    if (customer.birthDate)
                        this.birthDateString = $filter('date')(customer.birthDate, 'shortDate');
                    this.hasWebPwd = customer.hasWebPwd;
                    this.hasMobileApp = customer.hasMobileApp;
                    this.isCGVAccepted = customer.isCGVAccepted;
                    this.idReserveWithGoogle = customer.idReserveWithGoogle;
                }
            };
            CustomerView.prototype.copyDataTo = function (customer) {
                customer.lastName = this.lastName;
                customer.firstName = this.firstName;
                if (this.phone != null) {
                    customer.phone = this.phone;
                    if ((this.phoneCountry && this.phoneCountry != PhoneFormat.unknowFormat) || this.phoneCountry == null)
                        this.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(this.phone);

                    if (this.phoneCountry && this.phoneCountry != PhoneFormat.unknowFormat)
                        customer.phone = PhoneFormat.formatNumberWithInternationalFormat(this.phone, this.phoneCountry);
                    customer.phone = customer.phone.replace(/\s/g, '');
                }
                else {
                    customer.phone = null;
                    this.phoneDisplay = null;
                }


                if (this.landline != null)
                    customer.landline = this.landline.replace(/\s/g, '');
                else
                    customer.landline = null;
                customer.email = this.email;
                customer.comment = this.comment;
                customer.gender = this.gender;

                customer.isVerified = this.isVerified;
                customer.address1 = this.address1;
                customer.address2 = this.address2;
                customer.city = this.city;
                customer.postCode = this.postCode;
                customer.origin = this.origin;
                customer.online = this.online;
                customer.birthDate = this.birthDate;
                customer.isBirthDate = this.isBirthDate;
                customer.isCGVAccepted = this.isCGVAccepted;

                if (this.password)
                    customer.password = this.password;
                if (this.currentPassword)
                    customer.currentPassword = this.currentPassword;

                customer.idReserveWithGoogle = this.idReserveWithGoogle;
            };

            CustomerView.prototype.addLine = function (date, iconStatus, techNote, iconTechnote) {
                var lineContent = "";
                lineContent += '<tr>' +
                    '<td style="border-top: 1px solid #000000;width: 75px;margin-top: 2px;">' + (date ? date : '&nbsp;') +
                    '</td>' +
                    '<td style="border-top: 1px solid #000000;width: 15px;margin-top: 2px;">' + iconStatus +
                    '</td>' +
                    '<td style="border-top: 1px solid #000000;width: 75px;margin-top: 2px;"><span>' + iconTechnote + '&nbsp;' + techNote + '</span>' +
                    '</td>' +
                    '</tr>';
                return lineContent;
            }

            CustomerView.prototype.getIconStatus = function (status, isUnpaid) {
                switch (status) {
                    case 'came':
                        return '<span><i class="fal fa-thumbs-up booking-icon-came" style="padding:0 1px"></i></span>';
                    case 'notCame':
                        return '<span><i class="fal fa-thumbs-down booking-icon-not-came" style="padding:0 1px"></i></span>';
                    case 'waiting':
                        return '<span><i class="fas fa-pause" style="  position: absolute;left: 9px;top: 12px;font-size: 6px;"></i><img ng-src="{{bookingStatusImage.waiting}}" alt="waiting-sale"/></span>';
                    case 'sold':
                        if (isUnpaid)
                            return '<span class="fa-stack" style="width: 1em;height: 1em;line-height: 1em;">\n' +
                                '<i class="fal fa-euro fa-stack-1x"></i><i class="fal fa-ban fa-stack-2x" style="color:#e20000;font-size: 1.4em;top: -4px;left: -1px;"></i></span>';
                        else
                            return '<span><img ng-src="{{bookingStatusImage.paid}}" alt="paid-sale"/></span>';
                    case 'soldProcess':
                        return '<span><i class="fal fa-circle-o-notch fa-spin" style="padding:1px 0px"></i></span>';
                    case 'advanceKeeped':
                    case 'advance':
                        return '<span><img ng-src="{{bookingStatusImage.advance}}" alt="advance-sale"/></span>';
                    case 'advanceProcess':
                        return '<span><i class="fal fa-circle-o-notch fa-spin" style="padding:1px 0px"></i></span>';
                    default:
                        return '';
                }
            };

            CustomerView.prototype.getIconTechNote = function (items) {
                let cpt = 0;
                let labels = "";
                for (let i = 0; i < items.length; i++) {
                    if (items[i].type && items[i].type === 'service') {
                        cpt++;
                    }
                    if (cpt > 1) {
                        labels += '<span>,' + items[i].label + '</span>';
                    } else {
                        labels += '<span>' + items[i].label + '</span>';
                    }
                }
                let icon = cpt === 0 ? 'fal fa-tag' : 'fal fa-tags';
                return '<i class="' + icon + '" style="padding:1px 0px"></i>&nbsp;' + labels;
            };

            CustomerView.prototype.printTechnicalSheet = function () {
                let onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
                if(IOSDevice.isIOSDevice()) {
                    onLoadContent = "window.print();";
                }
                let documentContent = '<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" type="text/css" href="/css/print.css" />' +
                    '<link rel="stylesheet" href="//netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.css"/>' +
                    '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' +
                    '<script src="/lib/barcode/JsBarcode.js"></script>' +
                    '<script src="/lib/barcode/EAN_UPC.js"></script>' +
                    '</head><body onload="' + onLoadContent + '"><div class="reward-body">' +
                    '<div class="name">' + this.firstName + '&nbsp;' + this.lastName + '</div>' +
                    '<div class="adress">' + (this.email ? this.email : "") + '</div>' +
                    '<div class="phone">' + (this.phone ? this.phone : "")+ '</div><br/>';

                documentContent += '<table class="bill" style="width: 100%">';
                documentContent += '' +
                    '<tr>' +
                    '<th class="price-tva" style="width:30px;text-align: left">Date</th>' +
                    '<th class="price-tva" style="width:15px;text-align: left"><i class="fal fa-info-circle"></th>' +
                    '<th class="price-tva" style="width:30px;text-align: left">Fiche technique</th>' +
                    '</tr>' +
                    '<tbody >';

                for (let i = 0; i < this.techNoteHistory.length; i++) {
                    let bookOfSaleView = this.techNoteHistory[i];
                    if (bookOfSaleView.techNote) {
                        let iconStatus = this.getIconStatus(bookOfSaleView.status, bookOfSaleView.unpaid);
                        documentContent += this.addLine($filter('date')(bookOfSaleView.date, 'dd/MM/yyyy'), iconStatus, bookOfSaleView.techNote, this.getIconTechNote(bookOfSaleView.items));
                    }
                }
                documentContent += '</tbody></table>';
                documentContent += '</div></body></html>';
                this.printWindow.document.write(documentContent);
                this.printWindow.document.title = "Imprimer";
                this.printWindow.document.close();
            };

            CustomerView.prototype.openPrintWindow = function () {
                let left = (screen.width / 2) - (800 / 2);
                let top = (screen.height / 2) - (500 / 2);
                this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
                if (this.printWindow) {
                    this.printWindow.window.focus();
                }
            };

            CustomerView.prototype.addBookingView = function (bookingView) {
                if (bookingView && bookingView.date) {
                    let now = new Date();
                    let bookingsView;
                    let bookingViewTime = bookingView.date.getTime() + bookingView.period.start.getTime() * 60000;
                    if (bookingViewTime < now.getTime()) {
                        bookingsView = this.pastBookingsView;
                    } else {
                        bookingsView = this.futureBookingsView;
                    }
                    if (!bookingsView) {
                        bookingsView = [];
                    }
                    let index = bookingsView.indexOf(bookingView);
                    if (index == -1) {  //insert sorted
                        for (let i = 0; i < bookingsView.length; i++)
                            if (bookingViewTime <= bookingsView[i].date.getTime() + bookingsView[i].period.start.getTime() * 60000) {
                                //insert
                                bookingsView.splice(i, 0, bookingView);
                                return;//Stop
                            }
                        bookingsView.push(bookingView);
                    }
                }
            };

            CustomerView.prototype.removeBookingView = function (bookingView)//
            {
                var index = this.futureBookingsView.indexOf(bookingView);
                if (index != -1)   //insert sorted
                {
                    this.futureBookingsView.splice(index, 1);
                }
            };

            CustomerView.prototype.onBirthDateStringKeyup = function (event)//
            {
                if (this.birthDateString)
                    if (!(event && (event.which == 8 || event.which == 46))) //if key delete detected : clear supplier
                    {
                        if ((this.birthDateString.length == 4 || this.birthDateString.length == 7) && (this.birthDateString[this.birthDateString.length - 1] == '/'))
                            this.birthDateString = this.birthDateString.substr(0, this.birthDateString.length - 2);

                        if (this.birthDateString.length == 2 || this.birthDateString.length == 5)
                            this.birthDateString += "/";
                    }
            };
            CustomerView.prototype.displayCustomerDatePickerF = function () {
                var customerView = this;
                $timeout(function () {
                    customerView.birthDatePickerOpened = true;
                })
            };
            CustomerView.prototype.onBirthDateStringUpdate = function ()//
            {
                if (this.birthDateString && this.birthDateString.length == 10) {
                    var year = this.birthDateString.substring(6, 10);
                    var month = this.birthDateString.substring(3, 5);
                    var day = this.birthDateString.substring(0, 2);
                    this.birthDate = new Date(year + '/' + month + '/' + day);
                    if (this.birthDate)
                        if (Object.prototype.toString.call(this.birthDate) === "[object Date]") {
                            if (isNaN(this.birthDate.getTime()))
                                this.birthDate = null;
                        }
                        else {
                            this.birthDate = null;
                        }
                }
                else
                    this.birthDate = null;
            }
            CustomerView.prototype.updateBirthDateString = function () {
                if (this.birthDate)
                    this.birthDateString = $filter('date')(this.birthDate, 'shortDate');
            }

            CustomerView.prototype.displayBirthDay = function () {
                if (this.birthDate)
                    return $filter('date')(this.birthDate, 'dd-MMM');
            }

            CustomerView.prototype.initGiftItemsView = function (isOnWebSite) {
                this.giftItemsUsedView = [];
                this.giftItemsNotUsedView = [];
                this.giftItemsCanceledView = [];
                var customer = this.getModel();
                var saleView;
                var dayView;
                if (customer && customer.giftItems)
                    for (var i = 0; i < customer.giftItems.length; i++) {
                        if (isOnWebSite || (customer.giftItems[i].sale && customer.giftItems[i].sale.status == "sold"))//on webSite giftItems[i].sale is null
                        {
                            var giftItemView = {
                                giIndex: GiftItemData.getIndexOf(customer.giftItems[i]),
                                index: i,
                                code: GiftItemView.getFormattedCode(customer.giftItems[i].code),
                                originalPrice: customer.giftItems[i].originalPrice,
                                validityDate: customer.giftItems[i].validityDate,
                                customerView: this,
                                serviceView: customer.giftItems[i].service ? this.domainView.getServiceView(customer.giftItems[i].service) : null,
                                getCustomerOfSale: function () {
                                    var customerOfSale = null;
                                    if (customer.giftItems[this.index] && customer.giftItems[this.index].sale && customer.giftItems[this.index].sale.customer) {
                                        customerOfSale = customer.giftItems[this.index].sale.customer;
                                    }
                                    return customerOfSale;
                                }
                            };
                            if (customer.giftItems[i].isCanceled)
                                this.giftItemsCanceledView.push(giftItemView);
                            else if (customer.giftItems[i].isUsed)
                                this.giftItemsUsedView.push(giftItemView);
                            else
                                this.giftItemsNotUsedView.push(giftItemView);

                        }
                    }
                this.nbGiftItemsUsed = this.giftItemsUsedView.length;
                this.nbGiftItemsNotUsed = this.giftItemsNotUsedView.length;
            };
            CustomerView.prototype.updateGiftItemsView = function (giftItemView) {
                if (giftItemView) {
                    var index = this.giftItemsNotUsedView.indexOf(giftItemView);
                    if (index != -1) {
                        if (giftItemView.isUsed) {
                            this.giftItemsNotUsedView.splice(index, 1);
                            this.giftItemsUsedView.push(giftItemView);
                        }
                    }
                    else {
                        index = this.giftItemsUsedView.indexOf(giftItemView);
                        if (index != -1) {
                            if (!giftItemView.isUsed) {
                                this.giftItemsUsedView.splice(index, 1);
                                this.giftItemsNotUsedView.push(giftItemView);
                            }
                        }
                    }
                    this.nbGiftItemsUsed = this.giftItemsUsedView.length;
                    this.nbGiftItemsNotUsed = this.giftItemsNotUsedView.length;

                }

            };

            CustomerView.prototype.updateCureItemViewFromModel = function (cureItem)//
            {
                var cCureItem;
                for (var i = 0; i < this.cureItemsNotUsedView.length; i++) {
                    cCureItem = this.cureItemsNotUsedView[i].getModel();
                    if (cCureItem && cCureItem.id == cureItem.id) {
                        this.cureItemsNotUsedView[i].loadDataFrom(cureItem);
                        return;
                    }
                }
                for (var i = 0; i < this.cureItemsUsedView.length; i++) {
                    cCureItem = this.cureItemsUsedView[i].getModel();
                    if (cCureItem && cCureItem.id == cureItem.id) {
                        this.cureItemsUsedView[i].loadDataFrom(cureItem);
                        return;
                    }
                }

            };

            CustomerView.prototype.updateServiceSelectable = function ()//
            {
                var todoServices = [];
                for (var i = 0; i < this.cureItemsNotUsedView.length; i++)
                    this.cureItemsNotUsedView[i].updateServiceSelectableForCure(todoServices);
                for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
                    if (this.giftItemsNotUsedView[i].serviceView) {
                        var giftItem = GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex);
                        if (giftItem.service) {
                            var serviceView = this.domainView.getServiceView(giftItem.service);
                            if (serviceView) {
                                if (todoServices.indexOf(serviceView) == -1)
                                    todoServices.push(serviceView);
                                serviceView.nbSelectableForGift++;
                            }
                        }

                    }
                }
                ;
                this.proposedServices = [];
                for (var i = 0; i < todoServices.length; i++)
                    this.proposedServices.push({
                        bsView: {serviceView: todoServices[i]},
                        occ: 0,
                        isRealBookingService: false
                    });
                var found = -1;
                for (var i = 0; i < this.historyBookingsView.length; i++) {
                    for (var j = 0; j < this.historyBookingsView[i].bookingServicesView.length; j++) {
                        found = -1;
                        for (var k = 0; k < this.proposedServices.length && found == -1; k++) {
                            if (this.proposedServices[k].bsView.serviceView === this.historyBookingsView[i].bookingServicesView[j].serviceView)
                                found = k;
                        }
                        if (found == -1)
                            this.proposedServices.push({
                                bsView: this.historyBookingsView[i].bookingServicesView[j],
                                occ: 1,
                                isRealBookingService: true
                            });
                        else {
                            if (!this.proposedServices[found].isRealBookingService) {
                                this.proposedServices[found].bsView = this.historyBookingsView[i].bookingServicesView[j];
                                this.proposedServices[found].isRealBookingService = true;
                            }
                            this.proposedServices[found].occ++;
                        }
                    }
                }


            };

            CustomerView.prototype.initHistoryView = function () {
                let customer = this.getModel();
                if (customer && customer.bookings) {
                    this.nbNotCameBookings = 0;
                    this.nbCameBookings = 0;
                    this.nbSoldSales = 0;
                    this.nbWaitingSales = 0;
                    this.nbEstimationSales = 0;
                    this.nbUnpaidSales = 0;
                    this.nbAdvanceSales = 0;
                    this.nbLoyaltyCardItemNotUsed = 0;
                    this.nbLoyaltyCardItemUsed = 0;
                    this.globalHistoryView = [];
                    this.techNoteHistory = [];
                    this.historyBookingsView = [];
                    this.historySoldSalesView = [];
                    this.historySoldPrice = 0;
                    this.historyRealPaidPrice = 0;
                    this.historyCaPrice = 0;
                    this.loyaltyCardItemsUsedView = [];
                    this.loyaltyCardItemsNotUsedView = [];
                    this.nbTechNotes = 0;

                    let prevCureItemsUsedView = this.cureItemsNotUsedView;
                    this.cureItemsUsedView = [];
                    let prevCureItemsNotUsedView = this.cureItemsNotUsedView;
                    this.cureItemsNotUsedView = [];
                    let readOnlyBookingsView = [];
                    let booking, bs;
                    let hr, hrLabel;
                    let lView;
                    let saleCureMinView, cureItem, cureItemView;
                    for (let i = 0; i < customer.bookings.length; i++) {
                        booking = new ReadOnlyBookingView(customer.bookings[i], this);
                        let date = null;
                        if (customer.bookings[i].day) {
                            date = customer.bookings[i].day.getDate();
                        }
                        let techNoteServiceItems = [];
                        let minBooking = {
                            index: BookingData.getIndexOf(customer.bookings[i]),
                            price: customer.bookings[i].sale ? customer.bookings[i].sale.price : customer.bookings[i].price,
                            date: date,
                            isBooking: true,
                            bookingTime: null,
                            status: "",
                            items: [],
                            unpaid: false,
                            bookingPeriod: customer.bookings[i].period
                        };
                        if (customer.bookings[i].period) {
                            minBooking.bookingTime = customer.bookings[i].period.start.getLabel();
                        }
                        if (customer.bookings[i].sale) {
                            minBooking.status = customer.bookings[i].sale.status;
                        } else {
                            minBooking.status = customer.bookings[i].status;
                        }
                        if (customer.bookings[i].sale && customer.bookings[i].sale.status === "sold") {
                            if (customer.bookings[i].sale.hasPaymentType("UNPAID")) {
                                this.nbUnpaidSales++;
                                minBooking.unpaid = true;
                            } else {
                                this.nbSoldSales++;
                            }
                            for (let j = 0; j < customer.bookings[i].bookingServices.length; j++) {
                                if (customer.bookings[i].bookingServices[j].cureItemToServiceUsage) {//add services with cureItemToServiceUsage (because not inside sale)
                                    hrLabel = "";
                                    if (customer.bookings[i].bookingServices[j].isPackage) {
                                        bs = customer.bookings[i].bookingServices[j];
                                        for (let k = 0; k < bs.subBookingServices.length; k++)
                                            if (bs.subBookingServices[k].dayHr && bs.subBookingServices[k].dayHr.humanResourceId) {
                                                hr = HumanResourceData.getById(bs.subBookingServices[k].dayHr.humanResourceId);
                                                if (hr && hrLabel.indexOf(hr.label) === -1) {
                                                    if (hrLabel !== "") {
                                                        hrLabel += " ";
                                                    }
                                                    hrLabel += hr.label;
                                                }
                                            }
                                    } else if (customer.bookings[i].bookingServices[j].dayHr && customer.bookings[i].bookingServices[j].dayHr.humanResourceId) {
                                        hr = HumanResourceData.getById(customer.bookings[i].bookingServices[j].dayHr.humanResourceId);
                                        if (hr) {
                                            hrLabel = hr.label
                                        }
                                    }
                                    minBooking.items.push({
                                        type: "service",
                                        label: customer.bookings[i].bookingServices[j].label,
                                        hrLabel: hrLabel
                                    });
                                    techNoteServiceItems.push({
                                        label: customer.bookings[i].bookingServices[j].label
                                    });
                                }
                            }
                            for (let j = 0; j < customer.bookings[i].sale.saleServices.length; j++) {
                                minBooking.items.push({
                                    type: "service",
                                    label: customer.bookings[i].sale.saleServices[j].label,
                                    hrLabel: customer.bookings[i].sale.saleServices[j].humanResource ? customer.bookings[i].sale.saleServices[j].humanResource.label : null
                                });

                                techNoteServiceItems.push({
                                    label: customer.bookings[i].sale.saleServices[j].label
                                });
                            }
                            for (let j = 0; j < customer.bookings[i].sale.saleProducts.length; j++) {
                                minBooking.items.push({
                                    type: "product",
                                    label: customer.bookings[i].sale.saleProducts[j].label,
                                    hrLabel: customer.bookings[i].sale.saleProducts[j].humanResource ? customer.bookings[i].sale.saleProducts[j].humanResource.label : null
                                });
                            }
                            for (let j = 0; j < customer.bookings[i].sale.saleCures.length; j++) {
                                for (let k = 0; k < customer.bookings[i].sale.saleCures[j].cureItems.length; k++) {
                                    cureItem = customer.bookings[i].sale.saleCures[j].cureItems[k];
                                    if (cureItem.isUsed()) {
                                        saleCureMinView = {
                                            label: customer.bookings[i].sale.saleCures[j].label,
                                            price: customer.bookings[i].sale.saleCures[j].price
                                        };
                                        //search if already exist
                                        cureItemView = null;
                                        for (let l = 0; l < prevCureItemsUsedView.length && !cureItemView; l++) {
                                            if (prevCureItemsUsedView[l].getModel() === cureItem) {
                                                cureItemView = prevCureItemsUsedView[l];
                                            }
                                        }
                                        if (cureItemView) {
                                            cureItemView.reloadModel();
                                        } else {
                                            cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                        }
                                        this.cureItemsUsedView.push(cureItemView);
                                    } else {
                                        saleCureMinView = {
                                            label: customer.bookings[i].sale.saleCures[j].label,
                                            price: customer.bookings[i].sale.saleCures[j].price
                                        };
                                        //search if already exist
                                        cureItemView = null;
                                        for (let l = 0; l < prevCureItemsNotUsedView.length && !cureItemView; l++) {
                                            if (prevCureItemsNotUsedView[l].getModel() === cureItem) {
                                                cureItemView = prevCureItemsNotUsedView[l];
                                            }
                                        }
                                        if (cureItemView) {
                                            cureItemView.reloadModel();
                                        } else {
                                            cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                        }
                                        this.cureItemsNotUsedView.push(cureItemView);
                                    }
                                }
                                minBooking.items.push({
                                    type: "cure",
                                    label: customer.bookings[i].sale.saleCures[j].label,
                                    hrLabel: customer.bookings[i].sale.saleCures[j].humanResource ? customer.bookings[i].sale.saleCures[j].humanResource.label : null
                                })
                            }
                            for (let j = 0; j < customer.bookings[i].sale.loyaltyCardItems.length; j++) {
                                lView = {
                                    index: LoyaltyCardItemData.getIndexOf(customer.bookings[i].sale.loyaltyCardItems[j]),
                                    label: customer.bookings[i].sale.loyaltyCardItems[j].label,
                                    validityDate: customer.bookings[i].sale.loyaltyCardItems[j].validityDate,
                                    pts: customer.bookings[i].sale.loyaltyCardItems[j].pts
                                };
                                if (customer.bookings[i].sale.loyaltyCardItems[j].isUsed) {
                                    this.loyaltyCardItemsUsedView.push(lView);
                                } else {
                                    this.loyaltyCardItemsNotUsedView.push(lView);
                                }
                                minBooking.items.push({
                                    type: "loyaltyCard",
                                    label: customer.bookings[i].sale.loyaltyCardItems[j].label,
                                    hrLabel: customer.bookings[i].sale.loyaltyCardItems[j].humanResource ? customer.bookings[i].sale.loyaltyCardItems[j].humanResource.label : null
                                });

                            }
                            for (let j = 0; j < customer.bookings[i].sale.giftItems.length; j++) {
                                minBooking.items.push({
                                    type: "gift",
                                    label: "Bon cadeau de " + $filter('currencyFormatFilter')(customer.bookings[i].sale.giftItems[j].originalPrice),
                                    hrLabel: customer.bookings[i].sale.giftItems[j].humanResource ? customer.bookings[i].sale.giftItems[j].humanResource.label : null
                                });
                            }
                            this.historySoldPrice += customer.bookings[i].sale.price;
                            this.historyRealPaidPrice += customer.bookings[i].sale.realPaidPrice;
                            this.historyCaPrice += customer.bookings[i].sale.price - customer.bookings[i].sale.giftItemsPrice;
                        } else {
                            if (customer.bookings[i].sale && customer.bookings[i].sale.status === "waiting") {
                                this.nbWaitingSales++;
                            }
                            if (customer.bookings[i].sale && customer.bookings[i].sale.status === "advance") {
                                this.nbAdvanceSales++;
                            }
                            for (let j = 0; j < customer.bookings[i].bookingServices.length; j++) {
                                hrLabel = "";
                                if (customer.bookings[i].bookingServices[j].isPackage) {
                                    bs = customer.bookings[i].bookingServices[j];
                                    for (let k = 0; k < bs.subBookingServices.length; k++) {
                                        if (bs.subBookingServices[k].dayHr && bs.subBookingServices[k].dayHr.humanResourceId) {
                                            hr = HumanResourceData.getById(bs.subBookingServices[k].dayHr.humanResourceId);
                                            if (hr && hrLabel.indexOf(hr.label) === -1) {
                                                if (hrLabel !== "")
                                                    hrLabel += " ";
                                                hrLabel += hr.label;
                                            }
                                        }
                                    }
                                }
                                else if (customer.bookings[i].bookingServices[j].dayHr && customer.bookings[i].bookingServices[j].dayHr.humanResourceId) {
                                    hr = HumanResourceData.getById(customer.bookings[i].bookingServices[j].dayHr.humanResourceId);
                                    if (hr) {
                                        hrLabel = hr.label
                                    }
                                }
                                minBooking.items.push({
                                    type: "service",
                                    label: customer.bookings[i].bookingServices[j].label,
                                    hrLabel: hrLabel
                                });
                                techNoteServiceItems.push({
                                    label: customer.bookings[i].bookingServices[j].label
                                });
                            }
                        }
                        readOnlyBookingsView.push(booking);
                        this.globalHistoryView.push(minBooking);
                        if (!(customer.bookings[i].sale && (customer.bookings[i].sale.status === SaleStatus.WAITING || customer.bookings[i].sale.status === SaleStatus.SOLD || customer.bookings[i].sale.status === SaleStatus.ADVANCE))) {
                            switch (customer.bookings[i].status) {
                                case 'notCame':
                                    this.nbNotCameBookings++;
                                    break;
                                case 'came':
                                    this.nbCameBookings++;
                                    break;
                            }
                        }
                        if (customer.bookings[i].day && (!this.lastVisitDate || (this.lastVisitDate.getTime() < customer.bookings[i].day.getDate().getTime()))) {
                            this.lastVisitDate = customer.bookings[i].day.getDate();
                        }
                        if (!customer.bookings[i].sale && customer.bookings[i].techNote && customer.bookings[i].techNote !== '') {
                            this.addTechNoteToHistoryFromBooking(customer.bookings[i], customer.bookings[i].techNote, techNoteServiceItems);
                        }
                    }
                    this.historyBookingsView = $filter('orderBy')(readOnlyBookingsView, 'date', true);//execute angular filter

                    for (let i = 0; i < customer.sales.length; i++) {
                        let techNoteServiceItems = [];
                        if((customer.sales[i].status === SaleStatus.WAITING || customer.sales[i].status === SaleStatus.ESTIMATION || customer.sales[i].status === SaleStatus.SOLD || customer.sales[i].status === SaleStatus.ADVANCE)) {
                            if (!customer.sales[i].booking) {
                                let date = null;
                                if (customer.sales[i].day) {
                                    date = customer.sales[i].day.getDate();
                                }
                                let minSale = {
                                    index: SaleData.getIndexOf(customer.sales[i]),
                                    price: customer.sales[i].price,
                                    date: date,
                                    isBooking: false,
                                    status: customer.sales[i].status,
                                    items: [],
                                    unpaid: false
                                };
                                if (customer.sales[i].status === "waiting" && customer.sales[i].booking) {
                                    for (let j = 0; j < customer.sales[i].booking.bookingServices.length; j++) {
                                        minSale.items.push({
                                            type: "service",
                                            label: customer.sales[i].booking.bookingServices[j].label,
                                            hrLabel: null
                                        });
                                        techNoteServiceItems.push({
                                            label: customer.sales[i].booking.bookingServices[j].label
                                        });
                                    }
                                } else {
                                    for (let j = 0; j < customer.sales[i].saleServices.length; j++) {
                                        minSale.items.push({
                                            type: "service",
                                            label: customer.sales[i].saleServices[j].label,
                                            hrLabel: customer.sales[i].saleServices[j].humanResource ? customer.sales[i].saleServices[j].humanResource.label : null
                                        });
                                        techNoteServiceItems.push({
                                            label: customer.sales[i].saleServices[j].label
                                        });
                                    }
                                }
                                for (let j = 0; j < customer.sales[i].saleProducts.length; j++) {
                                    minSale.items.push({
                                        type: "product",
                                        label: customer.sales[i].saleProducts[j].label,
                                        hrLabel: customer.sales[i].saleProducts[j].humanResource ? customer.sales[i].saleProducts[j].humanResource.label : null
                                    });
                                }
                                if (customer.sales[i].status !== "waiting") {
                                    for (let j = 0; j < customer.sales[i].loyaltyCardItems.length; j++) {
                                        lView = {
                                            index: LoyaltyCardItemData.getIndexOf(customer.sales[i].loyaltyCardItems[j]),
                                            label: customer.sales[i].loyaltyCardItems[j].label,
                                            validityDate: customer.sales[i].loyaltyCardItems[j].validityDate,
                                            pts: customer.sales[i].loyaltyCardItems[j].pts
                                        };
                                        if (customer.sales[i].loyaltyCardItems[j].isUsed) {
                                            this.loyaltyCardItemsUsedView.push(lView);
                                        } else {
                                            this.loyaltyCardItemsNotUsedView.push(lView);
                                        }
                                        minSale.items.push({
                                            type: "loyaltyCard",
                                            label: customer.sales[i].loyaltyCardItems[j].label,
                                            hrLabel: customer.sales[i].loyaltyCardItems[j].humanResource ? customer.sales[i].loyaltyCardItems[j].humanResource.label : null
                                        });
                                    }
                                }
                                for (let j = 0; j < customer.sales[i].saleCures.length; j++) {
                                    for (let k = 0; k < customer.sales[i].saleCures[j].cureItems.length; k++) {
                                        cureItem = customer.sales[i].saleCures[j].cureItems[k];
                                        if (cureItem.isUsed()) {
                                            saleCureMinView = {
                                                label: customer.sales[i].saleCures[j].label,
                                                price: customer.sales[i].saleCures[j].originalPrice
                                            };
                                            if (customer.sales[i].status === "sold") {
                                                //search if already exist
                                                cureItemView = null;
                                                for (let l = 0; l < prevCureItemsUsedView.length && !cureItemView; l++)
                                                    if (prevCureItemsUsedView[l].getModel() === cureItem) {
                                                        cureItemView = prevCureItemsUsedView[l];
                                                    }
                                                if (cureItemView) {
                                                    cureItemView.reloadModel();
                                                } else {
                                                    cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                                }
                                                this.cureItemsUsedView.push(cureItemView);
                                            }
                                        } else {
                                            saleCureMinView = {
                                                label: customer.sales[i].saleCures[j].label,
                                                price: customer.sales[i].saleCures[j].originalPrice
                                            };
                                            if (customer.sales[i].status === "sold") {
                                                //search if already exist
                                                cureItemView = null;
                                                for (let l = 0; l < prevCureItemsNotUsedView.length && !cureItemView; l++)
                                                    if (prevCureItemsNotUsedView[l].getModel() === cureItem) {
                                                        cureItemView = prevCureItemsNotUsedView[l];
                                                    }
                                                if (cureItemView) {
                                                    cureItemView.reloadModel();
                                                } else {
                                                    cureItemView = new CureItemView(cureItem, CureItemData.getIndexOf(cureItem), saleCureMinView, this.domainView);
                                                }
                                                this.cureItemsNotUsedView.push(cureItemView);
                                            }
                                        }
                                    }
                                    minSale.items.push({
                                        type: "cure",
                                        label: customer.sales[i].saleCures[j].label,
                                        hrLabel: customer.sales[i].saleCures[j].humanResource ? customer.sales[i].saleCures[j].humanResource.label : null
                                    })
                                }
                                for (let j = 0; j < customer.sales[i].giftItems.length; j++) {
                                    minSale.items.push({
                                        type: "gift",
                                        label: "Bon cadeau de " + $filter('currencyFormatFilter')(customer.sales[i].giftItems[j].originalPrice),
                                        hrLabel: customer.sales[i].giftItems[j].humanResource ? customer.sales[i].giftItems[j].humanResource.label : null
                                    });
                                }
                                if (customer.sales[i].status === "waiting") {
                                    this.nbWaitingSales++;
                                } else if (customer.sales[i].status === "estimation") {
                                    this.nbEstimationSales++;
                                } else if (customer.sales[i].status === "advance") {
                                    this.nbAdvanceSales++;
                                } else if (customer.sales[i].status === "sold") {
                                    if (customer.sales[i].hasPaymentType("UNPAID")) {
                                        minSale.unpaid = true;
                                        this.nbUnpaidSales++;
                                    } else {
                                        this.nbSoldSales++;
                                    }
                                    this.historySoldSalesView.push(minSale);
                                    this.historySoldPrice += customer.sales[i].price;
                                    this.historyCaPrice += customer.sales[i].price - customer.sales[i].giftItemsPrice;
                                    this.historyRealPaidPrice += customer.sales[i].realPaidPrice;
                                }
                                this.globalHistoryView.push(minSale);
                            } else {
                                for (let j = 0; j < customer.sales[i].booking.bookingServices.length; j++) {
                                    techNoteServiceItems.push({
                                        label: customer.sales[i].booking.bookingServices[j].label
                                    });
                                }
                            }
                            this.addTechNotesBySale(customer.sales[i], techNoteServiceItems);
                        }
                        if (customer.sales[i].day && (!this.lastVisitDate || this.lastVisitDate.getTime() < customer.sales[i].day.getDate().getTime())) {
                            this.lastVisitDate = customer.sales[i].day.getDate();
                        }
                    }
                    this.globalHistoryView = $filter('orderBy')(this.globalHistoryView, 'date', true);
                    this.nbCureItemNotUsed = this.cureItemsNotUsedView.length;
                    this.nbCureItemUsed = this.cureItemsUsedView.length;
                    this.nbLoyaltyCardItemNotUsed = this.loyaltyCardItemsNotUsedView.length;
                    this.nbLoyaltyCardItemUsed = this.loyaltyCardItemsUsedView.length;
                    this.techNoteHistory = $filter('orderBy')(this.techNoteHistory, 'date', true);
                    this.isHistoryInit = true;
                }
            };

            CustomerView.prototype.addTechNotesBySale = function (sale, techNoteServiceItems) {
                if ((sale.booking && sale.booking.techNote) || sale.techNote) {

                    if (sale.techNote) {
                        this.addTechNoteToHistoryFromSale(sale, sale.techNote, techNoteServiceItems);
                    }
                    if (sale.booking && sale.booking.techNote) {
                        this.addTechNoteToHistoryFromBooking(sale.booking, sale.booking.techNote, techNoteServiceItems);
                    }
                }
            };

            CustomerView.prototype.addTechNoteToHistoryFromBooking = function(booking, techNoteDescription, techNoteServiceItems) {
                if(booking && techNoteDescription) {
                    let date = booking.day.getDate();
                    let techNoteDatas = {
                        index: BookingData.getIndexOf(booking),
                        date: date,
                        techNote: techNoteDescription,
                        status: booking.status,
                        isBooking: true,
                        items: techNoteServiceItems
                    };
                    this.nbTechNotes++;
                    this.techNoteHistory.push(techNoteDatas);
                }
            };
            CustomerView.prototype.addTechNoteToHistoryFromSale = function(sale, techNoteDescription, techNoteServiceItems) {
                if(sale && techNoteDescription) {
                    let date = sale.day.getDate();
                    let techNoteDatas = {
                        index: SaleData.getIndexOf(sale),
                        date: date,
                        techNote: techNoteDescription,
                        status: sale.status,
                        isBooking: false,
                        items: techNoteServiceItems
                    };
                    this.nbTechNotes++;
                    this.techNoteHistory.push(techNoteDatas);
                }
            };
            CustomerView.prototype.getFirstCureItemToServiceViewByServiceView = function (serviceView) {
                var cureItemToServiceView = null;
                for (var i = 0; i < this.cureItemsNotUsedView.length && !cureItemToServiceView; i++)
                    cureItemToServiceView = this.cureItemsNotUsedView[i].getFirstCureItemToServiceViewByServiceView(serviceView);
                return cureItemToServiceView;
            };
            CustomerView.prototype.getFirstGiftItemViewByServiceView = function (serviceView) {
                var giftItemView = null;
                if (serviceView)
                    for (var i = 0; i < this.giftItemsNotUsedView.length; i++) {
                        if (this.giftItemsNotUsedView[i].serviceView) {
                            var giftItem = GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex)
                            if (giftItem.service === serviceView.getModel())
                                giftItemView = this.giftItemsNotUsedView[i];
                        }
                    }
                return giftItemView;
            };
            CustomerView.prototype.getCureItemToServiceUsageView = function (cureItemToServiceUsage) {
                if (cureItemToServiceUsage && cureItemToServiceUsage.cureItemToService && cureItemToServiceUsage.cureItemToService.cureItem)
                    for (var i = 0; i < this.cureItemsNotUsedView.length; i++)
                        if (this.cureItemsNotUsedView[i].getModel() === cureItemToServiceUsage.cureItemToService.cureItem)
                            return this.cureItemsNotUsedView[i].getCureItemToServiceUsageView(cureItemToServiceUsage);
                return null;
            };
            CustomerView.prototype.getGiftItemView = function (giftItem) {
                if (giftItem) {
                    for (var i = 0; i < this.giftItemsNotUsedView.length; i++)
                        if (GiftItemData.getByIndex(this.giftItemsNotUsedView[i].giIndex) === giftItem)
                            return this.giftItemsNotUsedView[i];
                    for (var i = 0; i < this.giftItemsUsedView.length; i++)
                        if (GiftItemData.getByIndex(this.giftItemsUsedView[i].giIndex) === giftItem)
                            return this.giftItemsUsedView[i];
                }
                return null;
            };
            CustomerView.prototype.isChanged = function () {
                var customer = this.getModel();
                if (customer)
                    return (
                        this.firstName !== customer.firstName ||
                        this.lastName !== customer.lastName ||
                        this.phone !== Format.formatNumber(customer.phone) ||
                        this.landline !== Format.formatNumber(customer.landline) ||
                        this.email !== customer.email ||
                        this.comment !== customer.comment ||
                        this.gender !== customer.gender ||
                        this.isVerified !== customer.isVerified ||
                        this.address1 !== customer.address1 ||
                        this.address2 !== customer.address2 ||
                        this.city !== customer.city ||
                        this.postCode !== customer.postCode ||
                        this.origin !== customer.origin ||
                        this.online !== customer.online ||
                        this.birthDate !== customer.birthDate ||
                        this.isBirthDate !== customer.isBirthDate
                    );
                else
                    return true;

            };
            CustomerView.prototype.update = function () {
                this.label = this.lastName + " " + this.firstName;
                if (this.label)
                    this.labelLowerCase = this.label.toLowerCase();

            };
            CustomerView.prototype.hasAddress = function () {
                return (this.address1 && this.address1 !== "" && this.city && this.city !== "" && this.postCode && this.postCode !== "");
            };
            CustomerView.prototype.removeModel = function () {
                var cust = this.getModel();
                if (cust != null)
                    CustomerSrv.remove(cust);
            };
            CustomerView.prototype.reloadModel = function()
        {
            var cust = this.getModel();
            if (cust!=null)
                this.loadDataFrom(cust);

        }
        CustomerView.prototype.updateModel = function(save, successFunction, errorFunction) {
            this.update();
            let customer = this.getModel();
            if (!customer) {
                customer = new Customer();
                this.cIndex = CustomerData.getIndexOf(customer);
            }

            this.copyDataTo(customer);

            this.loadCustomerLabelSearch(customer);

            if (save===undefined||save) {
                CustomerSrv.save(customer, successFunction, errorFunction);
            }
            this.isBirthDate = this.computeBirthDate();
        }
        CustomerView.prototype.restoreModel = function()
        {
            var customer = this.getModel();
            if (customer)
                CustomerSrv.restore(customer);
        }
        CustomerView.prototype.canSave = function()
        {
            if (this.birthDateString && this.birthDateString !== "" && !this.birthDate)//String defined but no birthdate
                return false;
            return (this.firstName && this.firstName !== "" && this.lastName && this.lastName !== "");
        }

        CustomerView.prototype.canRegisterOnWeb = function(updatePwd)
        {
           return (this.canSaveAccountOnWeb(updatePwd) && this.isCGVAccepted);
        }

        CustomerView.prototype.canSaveAccountOnWeb = function(updatePwd)
        {

            var can = this.firstName && this.firstName !== "" &&
                this.lastName && this.lastName !== "" &&
                this.email && this.email !== "" && this.email.indexOf('@') !== -1;
            if (this.birthDateString && this.birthDateString !== "" && !this.birthDate)//string defined but no birthdate
                return false;
            if (updatePwd)
                can = can && this.canChangePwdOnWeb();
            return can;

        }
        CustomerView.prototype.canChangePwdOnWeb = function()
        {
            return (
                    this.password && this.password !== "" &&
                    this.passwordAgain && this.passwordAgain !== "" &&
                    this.password ===  this.passwordAgain
                );
        }
        CustomerView.prototype.canLoginOnWeb = function()
        {
            return (
                    this.login && this.login !== "" &&
                    this.password && this.password !== ""
                );

        }
        //FIX ME : DUPLICATED FUNCTION
        CustomerView.prototype.hasValidCellPhone = function(isMandatory)
        {
            // if customer has a valid cellphone number
            if(!isMandatory) {
                // if not mandatory, phone number is not an obligation
                if (this.phone == null || this.phone === "")
                    return true;
            }
            if (this.phone && this.phone.length > 0) {
                if (this.phone[0] === '0' && this.phone.replace(/[^0-9]/g, '').length === 10 &&
                    this.phone.length === 14 &&
                    (this.phone[1] === '6' || this.phone[1] === '7')) {
                    // if length with only numbers equals 10 and if the first two numbers are 06 or 07
                    // french number
                    return true;
                }
                if (this.phone[0] === '+' && this.phone.length > 9) {
                    // international number
                    return true;
                }
            }
            return false;
        };

        CustomerView.prototype.hasValidLandLine = function()
        {
            // if site has a valid work phone number
            if(this.landline == null || this.landline === "")
                return true;
            if (this.landline && this.landline.length > 0) {
                if (this.landline[0] === '0' && this.landline.replace(/[^0-9]/g, '').length === 10 && this.landline.length === 14) {
                    // if length with only numbers equals 10 and if the first number is 0
                    // french number
                    return true;
                }
                if (this.landline[0] === '+') {
                    // international number
                    return true;
                }
            }

            return false;
        };

        CustomerView.prototype.canReceiveEmailMarketing = function(){
            var canReceive = true;
            if(this.optInOutView && this.optInOutView.isAgreementKnown() && !this.optInOutView.isEmailCampaignAllowed)
                canReceive = false;
            if(this.email == null || this.email === "")
                canReceive = false;

            return canReceive;
        };

        CustomerView.prototype.canReceiveSmsMarketing = function(){
            var canReceive = true;
            if(this.optInOutView && this.optInOutView.isAgreementKnown() && !this.optInOutView.isSmsCampaignAllowed)
                canReceive = false;
            if(this.phone == null || this.phone === "")
                canReceive = false;

            return canReceive;
        }

        CustomerView.prototype.canReceiveEmailOptInReminder = function()
        {
            var canReceive = true;
            if(this.optInOutView.isAgreementKnown())
                canReceive = false;
            if(!this.getModel() || this.getModel().email == null || this.getModel().email === "")
                canReceive = false;

            return canReceive;
        }

        CustomerView.prototype.canReceiveSmsOptInReminder = function()
        {
            var canReceiveSms = true;
            if(this.optInOutView.isAgreementKnown())
                canReceiveSms = false;
            else if(this.phone == null || this.phone === "")
                canReceiveSms = false;

            return canReceiveSms;
        }

        CustomerView.prototype.getVisibleOnWebSiteNotUsedGiftItems = function()
        {
            var webSiteNotUsedGiftItems = new Array();
            for(var i = 0; i < this.giftItemsNotUsedView.length; i++){
                if( this.giftItemsNotUsedView[i] &&
                    this.giftItemsNotUsedView[i].getCustomerOfSale() &&
                    this.giftItemsNotUsedView[i].customerView &&
                    this.giftItemsNotUsedView[i].customerView.getModel() &&
                    this.giftItemsNotUsedView[i].getCustomerOfSale() === this.giftItemsNotUsedView[i].customerView.getModel()){
                    webSiteNotUsedGiftItems.push(this.giftItemsNotUsedView[i]);
                }
            }
            return webSiteNotUsedGiftItems;
        };

        CustomerView.prototype.getModelEmail = function()
        {
            let model = this.getModel(),
                email = null;
            if(model)
                email = model.email;
            return email;
        };

        CustomerView.prototype.computeBirthDate = function(){
            let copyBirthDate = new Date(this.birthDate);
            if (copyBirthDate) {
                let now = new Date();
                let minLocalDate = now.setDate(now.getDate() - 14);
                let maxLocalDate = now.setDate(now.getDate() + 28);
                let compareLocalBirthDay = copyBirthDate.setUTCFullYear(now.getUTCFullYear());
                return compareLocalBirthDay > minLocalDate && compareLocalBirthDay < maxLocalDate;
            }
             return false;
        };


        CustomerView.prototype.getPostsViewByCustomerId = function(){
            let posts = CustomerPostData.getActiveList(),
                customerPostViews = [];

            if(this.getModel()){
                let customerId = this.getModel().getId();
                for(let i = 0; i < posts.length ; i++){
                    //Don't replace this == by a === in this method. We need implicit cast comparison
                    if(customerId == posts[i].customerId){
                        let customerPostView = new CustomerPostView(posts[i], i);
                        customerPostViews.push(customerPostView);
                    }
                }
            }
            return customerPostViews;
        };

        return  CustomerView;
    }]);




// WEBPACK FOOTER //
// ./js/services/views/CustomerView.js